import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import LoadingButtonGeneral from './loadingButtonGeneral';
import { SxProps } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import EyeIcon from '@mui/icons-material/RemoveRedEye';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { ActionButtonGroupProps } from '../../../../shared/types/shared';

const ActionButtonGroup = ({
    buttonCreate,
    buttonSearch,
    buttonUpdate,
    buttonView,
    buttonLog,
    id,
    extraParam,
    onHistoricalShow,
}: ActionButtonGroupProps) => {
    const navigate = useNavigate();
    const textBtnStyle: SxProps = { display: { xs: 'none', lg: 'block' } };
    const btnIconStyle: SxProps = { marginRight: { xs: -1, lg: undefined } };

    const handleNavigation = (targetPath?: string) => {
        if (!targetPath) return;
        if (window.location.pathname === targetPath) {
            window.location.reload();
        } else {
            navigate(targetPath);
        }
    };

    const [, setShowHistorical] = useState(false);
    const handleHistoricalshow = () => {
        setShowHistorical(true);
        onHistoricalShow?.(true);
    };

    return (
        <>
            {buttonCreate && buttonCreate?.show && (
                <LoadingButtonGeneral
                    variant="outlined"
                    title="Crear"
                    sx={{ mr: 1 }}
                    onClick={() => {
                        handleNavigation(buttonCreate?.route);
                        window.location.reload();
                    }}
                    startIcon={<AddIcon sx={btnIconStyle} />}
                    textSx={textBtnStyle}
                />
            )}

            {buttonSearch && buttonSearch?.show && (
                <LoadingButtonGeneral
                    variant="outlined"
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={() => handleNavigation(buttonSearch?.route)}
                    startIcon={<SearchIcon sx={btnIconStyle} />}
                    textSx={textBtnStyle}
                />
            )}

            {buttonUpdate && id && buttonUpdate?.show && (
                <LoadingButtonGeneral
                    variant="outlined"
                    title="Editar"
                    sx={{ mr: 1 }}
                    onClick={() => {
                        const baseRoute = `${buttonUpdate?.route}/${id}`;
                        const finalRoute =
                            extraParam !== undefined && extraParam !== null
                                ? `${baseRoute}/${extraParam}`
                                : baseRoute;
                        handleNavigation(finalRoute);
                    }}
                    startIcon={<EditIcon sx={btnIconStyle} />}
                    textSx={textBtnStyle}
                />
            )}

            {buttonView && id && buttonView?.show && (
                <LoadingButtonGeneral
                    variant="outlined"
                    title="Ver"
                    sx={{ mr: 1 }}
                    onClick={() => {
                        const baseRoute = `${buttonView?.route}/${id}`;
                        const finalRoute =
                            extraParam !== undefined && extraParam !== null
                                ? `${baseRoute}/${extraParam}`
                                : baseRoute;
                        handleNavigation(finalRoute);
                    }}
                    startIcon={<EyeIcon sx={btnIconStyle} />}
                    textSx={textBtnStyle}
                />
            )}

            {buttonLog && buttonLog?.show && (
                <LoadingButtonGeneral
                    variant="outlined"
                    title="LOG"
                    sx={{ mr: 1 }}
                    onClick={handleHistoricalshow}
                    startIcon={<ListAltIcon sx={btnIconStyle} />}
                    textSx={textBtnStyle}
                />
            )}
        </>
    );
};

export default ActionButtonGroup;
